import { ClearOutlined, CommentOutlined, EditOutlined, FieldTimeOutlined, HomeOutlined, ScheduleOutlined, SkinOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import "index.css";
import { useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import navigationConfig from "configs/NavigationConfig";
import { getResolvedUserType } from "utils/MyMUtils";
import { getNavEntryHref, getUserModuleIds, isTopLevelNavVisible } from "utils/navUtils";
import NavProfileMenu from "../../../src/components/layout-components/NavProfileMenu";

const MainMenu = () => {
  const history = useHistory();
  const isSuperAdmin = parseInt(localStorage.getItem("is_super_admin") || "0") === 1;

  const openPopup = () => {
    const nav = document.getElementById("myNav");
    if (!nav) return; // managers are redirected before it renders
    nav.style.width = "100%";
    nav.style.transform = "scale(100%)";
  };

  useEffect(() => {
    openPopup();
  }, []);

  const redirectDashboard = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/dashboards");
  };

  const redirectStaffMaster = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/staff");
    window.location.reload();
  };

  const redirectUserMaster = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/user-management");
    window.location.reload();
  };

  const redirectFacilityPortalMaster = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/facility-portal");
    window.location.reload();
  };

  const redirectTimesheet = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/timesheet");
    window.location.reload();
  };

  const redirectCommunication = (value) => {
    localStorage.setItem("user_type", value);
    history.push("/app/communication-management");
    window.location.reload();
  };

  // Cleaning Audit, Laundry Audit, Employee Connect and Work Scheduler now run
  // inside this app (they used to auto-login to their own web apps). Each
  // module does its own handoff with its API, keyed by the same module id.
  const userModuleIds = getUserModuleIds();
  const hasModule = (id) => userModuleIds.includes(id);
  // Managers keep their login user_type (their sidebar lists just their
  // modules); a super admin may have narrowed it via a tile above, so reset it.
  const openModule = (path) => {
    if (isSuperAdmin) localStorage.setItem("user_type", "A");
    history.push(path);
  };

  const moduleCards = (
    <>
      {hasModule("18") && (
        <Col xs={20} md={8} lg={6}>
          <Card onClick={() => openModule("/app/cleaning-audit")} className="card_style" hoverable={true}>
            <Row>
              <Col span={6}>
                <ClearOutlined
                  style={{
                    fontSize: "16px",
                    color: "rgb(47, 111, 224)",
                  }}
                />
              </Col>
              <Col>
                <h4 style={{ textAlign: "left" }}>Cleaning Audit</h4>
                <p>Cleaning Management</p>
              </Col>
            </Row>
          </Card>
        </Col>
      )}
      {hasModule("19") && (
        <Col xs={20} md={8} lg={6}>
          <Card className="card_style" onClick={() => openModule("/app/laundry-audit")} hoverable={true}>
            <Row>
              <Col span={6}>
                <SkinOutlined
                  style={{
                    fontSize: "16px",
                    color: "rgb(47, 111, 224)",
                  }}
                />
              </Col>
              <Col>
                <h4 style={{ textAlign: "left" }}>Laundry Audit</h4>
                <p>Laundry Management</p>
              </Col>
            </Row>
          </Card>
        </Col>
      )}
      {hasModule("20") && (
        <Col xs={20} md={8} lg={6}>
          <Card className="card_style" onClick={() => openModule("/app/employee-connect")} hoverable={true}>
            <Row>
              <Col span={6}>
                <EditOutlined
                  style={{
                    fontSize: "16px",
                    color: "rgb(47, 111, 224)",
                  }}
                />
              </Col>
              <Col>
                <h4 style={{ textAlign: "left" }}>Employee Connect</h4>
                <p>Education Management</p>
              </Col>
            </Row>
          </Card>
        </Col>
      )}
      {hasModule("2") && (
        <Col xs={20} md={8} lg={6}>
          <Card className="card_style" onClick={() => openModule("/app/work-scheduler")} hoverable={true}>
            <Row>
              <Col span={6}>
                <ScheduleOutlined
                  style={{
                    fontSize: "16px",
                    color: "rgb(47, 111, 224)",
                  }}
                />
              </Col>
              <Col>
                <h4 style={{ textAlign: "left" }}>Work Scheduler</h4>
                <p>Periodical Management</p>
              </Col>
            </Row>
          </Card>
        </Col>
      )}
    </>
  );

  // Managers pick modules from the app's sidebar now, so they skip this
  // chooser and land on their first module. Without any module, they still
  // see the (empty) chooser, as before.
  // (their Dashboard first, else their first module)
  const managerEntries = isSuperAdmin
    ? []
    : navigationConfig.filter((menu) => isTopLevelNavVisible(menu, false, getResolvedUserType()) && getNavEntryHref(menu));
  const managerLanding = managerEntries.find((menu) => menu.key === "manager-dashboard") || managerEntries[0];
  if (managerLanding) {
    return <Redirect to={getNavEntryHref(managerLanding)} />;
  }

  return (
    <div>
      <div id="myNav" className="overlay-main-menu">
        <div className="modal_container">
          <Row style={{ backgroundColor: "#2f6fe0", alignItems: "center", padding: "12px 0" }}>
            <Col xs={12} md={14}>
              <img
                className="img-fluid"
                src="/img/asepsis-logo.png"
                alt=""
                style={{
                  marginTop: "8px",
                  paddingLeft: "10px",
                }}
              />
            </Col>
            <Col
              xs={12}
              md={10}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: "16px",
              }}
            >
              <div className="nav-right">
                <NavProfileMenu />
              </div>
            </Col>
          </Row>
        </div>

        {isSuperAdmin ? (
          /* Super Admin: show all module cards in original layout */
          <div className="overlay-content-main-menu">
            <div className="modal_container">
              <Row gutter={16} className="justify-content-center justify-content-md-start ml-0 mr-0">
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectDashboard("A")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <UserOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>Admin</h4>
                          <p>Admin Module</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectStaffMaster("H")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <UserOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>HR</h4>
                          <p>HR Module</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectUserMaster("U")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <TeamOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>Users</h4>
                          <p>User Management</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectFacilityPortalMaster("F")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <HomeOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>Facility</h4>
                          <p>Facility Management</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectTimesheet("T")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <FieldTimeOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>Timesheet</h4>
                          <p>Timesheet Module</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                <Col xs={20} md={8} lg={6}>
                  <a onClick={() => redirectCommunication("C")}>
                    <Card className="card_style" hoverable={true}>
                      <Row>
                        <Col span={6}>
                          <CommentOutlined style={{ fontSize: "16px", color: "rgb(47, 111, 224)" }} />
                        </Col>
                        <Col>
                          <h4 style={{ textAlign: "left" }}>Communication</h4>
                          <p>Communication Management</p>
                        </Col>
                      </Row>
                    </Card>
                  </a>
                </Col>
                {moduleCards}
              </Row>
            </div>
          </div>
        ) : (
          /* Manager: centered layout with only 4 module cards */
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 120px)",
            padding: "40px 20px",
          }}>
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2 style={{ color: "#fff", fontSize: "22px", fontWeight: 600, margin: 0 }}>
                Select a Module
              </h2>
              <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", marginTop: "8px" }}>
                Choose a module to get started
              </p>
            </div>
            <div className="modal_container">
              <Row gutter={[24, 24]} className="justify-content-center ml-0 mr-0">
                {moduleCards}
              </Row>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainMenu;
